import { useEffect } from 'react';

const SEO = ({ 
  title = "Your Setl. - Your place in nature | Luxury Country Cabins in Dorset", 
  description = "Escape to Your Setl - unique country cabins in the heart of Dorset. Reconnect with nature, embrace slowness, and find balance in our exclusive 8-cabin retreat on 3 acres of beautiful countryside.",
  keywords = "Dorset country cabins, luxury tiny houses Dorset, nature retreat UK, digital detox Dorset, countryside accommodation, farm stay Dorset, Jurassic Coast accommodation, eco cabins UK, slow living retreat",
  ogImage = "https://res.cloudinary.com/dvypx0zh5/image/upload/f_auto,q_auto:best/v1771402943/DSC_8350_dmznve.jpg",
  url = "https://www.yoursetl.co.uk",
  structuredData = null,
  noIndex = false
}) => {
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "LodgingBusiness",
    "name": "Your Setl",
    "description": "Exclusive country cabins on a working farm in Dorset, along the Jurassic Coast",
    "url": "https://www.yoursetl.co.uk",
    "image": ogImage,
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "Dorset",
      "addressCountry": "GB"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "50.7488",
      "longitude": "-2.3445"
    },
    "priceRange": "$$$$",
    "amenityFeature": [
      { "@type": "LocationFeatureSpecification", "name": "Working Farm" },
      { "@type": "LocationFeatureSpecification", "name": "Private Kitchen Garden" },
      { "@type": "LocationFeatureSpecification", "name": "Covered Terrace" }
    ]
  };

  useEffect(() => {
    const setMeta = (attr, attrValue, content) => {
      let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
      el.setAttribute('data-seo', 'true');
    };

    document.title = title;

    setMeta('name', 'title', title);
    setMeta('name', 'description', description);
    setMeta('name', 'keywords', keywords);
    setMeta('name', 'robots', noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
    setMeta('name', 'language', 'English');
    setMeta('name', 'author', 'Your Setl.');

    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', ogImage);
    setMeta('property', 'og:image:width', '1200');
    setMeta('property', 'og:image:height', '630');

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:url', url);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', ogImage);

    // Canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!noIndex) {
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', url);
    } else if (canonical) {
      canonical.remove();
    }

    // Structured Data (JSON-LD)
    let jsonLd = document.querySelector('script[data-seo-jsonld]');
    if (!noIndex) {
      const data = structuredData || defaultStructuredData;
      if (!jsonLd) {
        jsonLd = document.createElement('script');
        jsonLd.setAttribute('type', 'application/ld+json');
        jsonLd.setAttribute('data-seo-jsonld', 'true');
        document.head.appendChild(jsonLd);
      }
      jsonLd.textContent = JSON.stringify(data);
    } else if (jsonLd) {
      jsonLd.remove();
    }
  }, [title, description, keywords, ogImage, url, noIndex, structuredData]);

  return null;
};

export default SEO;
